import PropTypes from "prop-types";
import React from "react";
import Config from "config";

import { Container, Row, Col } from "reactstrap";

import { useEffect, useState } from "react";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import Spinners from "components/Common/Spinner";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import FactureCard from "components/Common/FactureCard";
import PaiementCard from "components/Common/PaiementCard";
import ContactDataCard from "components/Common/ContactCard";
import OrganisationCard from "components/Common/OrganisationCard";

const Dashboard = (props) => {
  //meta title
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  document.title = "Dashboard Factures | DOM COM INVEST";
  const [loading, setLoading] = useState(true);
  const history = useNavigate();
  // const token = useSelector((state) => state.Login.token); avec Redux
  const token = localStorage.getItem("auth_token_" + api);
  const [factureData, setFactureData] = useState([]);
  const getFactureData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_paiements/mes_factures`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const Data = await response.json();
      setFactureData(Data);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const [moyenData, setMoyenData] = useState([]);
  const getMoyenData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_paiements/moyens_de_paiement`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const Data = await response.json();
      setMoyenData(Data);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const [contactData, setContactData] = useState([]);
  const getContactData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_paiements/donnees_contact`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const Data = await response.json();
      setContactData(Data);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const [organisationData, setOrganisationData] = useState([]);
  const getOrganisationData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_paiements/donnees_organisation`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const Data = await response.json();
      setOrganisationData(Data);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const handleSuccess = () => {
    toast.success("Données enregistrées avec succès !");
  };
  const handleError = () => {
    toast.error("Un problème est survenu");
  };

  useEffect(() => {
    getFactureData();
    getMoyenData();
    getContactData();
    getOrganisationData();
  }, []);

  return (
    <>
      <ToastContainer />
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <h2>Factures</h2>
            <Link
              className="btn btn-sm btn-soft-primary mr-2"
              id="viewtooltip-2"
              to={`${backUrl}/fx_paiements/list`}
            >
              <i className="bx bx-caret-right"></i> Aller à historiques des
              factures
            </Link>
            <Row className="mt-3">
              {!loading ? (
                <>
                  {factureData != [] ? (
                    <>
                      <Col md="6">
                        <FactureCard
                          title={factureData.title}
                          data={factureData.data}
                          backUrl={backUrl}
                        />
                      </Col>
                    </>
                  ) : null}
                  {moyenData != [] ? (
                    <>
                      <Col md="6">
                        <PaiementCard
                          title={moyenData.title}
                          data={moyenData.data}
                        />
                        <ContactDataCard
                          title={contactData.title}
                          data={contactData.data}
                        />
                      </Col>
                    </>
                  ) : null}
                  {organisationData != [] ? (
                    <>
                      <Col md="6">
                        <OrganisationCard
                          title={organisationData.title}
                          data={organisationData.data}
                          onError={handleError}
                          onSuccess={handleSuccess}
                        />
                      </Col>
                    </>
                  ) : null}
                </>
              ) : (
                <Col>
                  <Spinners setLoading={setLoading} />
                </Col>
              )}
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
  history: PropTypes.object,
};

export default withTranslation()(Dashboard);
